import config from "./config";

const region = "us-east-1";

const apiId = {
  dev: "wb57twig5e",
  prod: "irdrpk32lc",
};

const awsmobile = {
  aws_project_region: region,
  aws_cognito_identity_pool_id:
    "us-east-1:0293386d-7444-4762-bfb7-774f99b2837e",
  aws_cognito_region: region,
  aws_user_pools_id: "us-east-1_hx5xDd8vY",
  aws_user_pools_web_client_id: "3slv1fmse1m9bosfdv92onck86",
  API: {
    endpoints: [
      {
        name: config.apiName,
        endpoint: `https://${
          apiId[config.stage]
        }.execute-api.${region}.amazonaws.com/${config.stage}`,
        region: region,
      },
    ],
  },
};

export default awsmobile;
